import React, { useEffect, useState } from 'react'
import { Box, Typography, CircularProgress, Alert, AlertTitle, Link } from '@mui/material'
import { useAuth } from 'src/common/context'
import * as S from './styles'
import { alertNotification, Container } from 'src/ui'
import WelcomeCard from './WelcomeCard'
import MintBurnSummary from './MintBurnSummary'
import { OrdersTable } from 'src/common/components'
import { getOrders, OrderDetails } from 'src/common/api'
import flagsmith from 'flagsmith'
import { DISPLAY_DASHBOARD_ALERT_FLAG } from 'src/common/api/flagsmith/sdcFeatureFlags'
import { AlertFlag } from 'src/common/api/flagsmith/flagInterface'

const Dashboard: React.FC = () => {
  const { user, socket } = useAuth()
  const [fetching, setFetching] = useState(true)
  const [orders, setOrders] = useState<OrderDetails[]>([])
  const [isFlagEnabled, setIsFlagEnabled] = useState(false)
  const [flagValue, setFlagValue] = useState<AlertFlag | null | undefined>(null)

  const fetchOrders = async () => {
    try {
      const response = await getOrders({ sortBy: 'NEWEST' })
      // Get the 5 most recent orders
      const recentOrders = response.data.orders.slice(0, 5)
      setOrders(recentOrders)
      setFetching(false)
    } catch (err) {
      alertNotification('Fetching orders failed. Please contact support.', 'error')
      setFetching(false)
    }
  }

  const getDashboardAlertFlag = async () => {
    const flag = flagsmith.getAllFlags()[DISPLAY_DASHBOARD_ALERT_FLAG]
    if (flag.enabled) {
      setIsFlagEnabled(flag.enabled)
      setFlagValue(JSON.parse(flag.value as string))
    }
  }
  useEffect(() => {
    fetchOrders()
    getDashboardAlertFlag()
    if (!socket) return

    socket.on('order', async () => {
      // TO-DO: could be optimized to fetch order by id, backend socket returns orderId
      await fetchOrders()
    })

    return () => {
      socket.off('order')
    }
  }, [])

  return (
    <S.DashboardContainer>
      <S.LeftSection>
        <S.SummaryContainer>
          <Box paddingTop={'50px'} mb={2}>
            {isFlagEnabled && (
              <Alert severity={flagValue?.alertType}>
                {' '}
                <AlertTitle> {flagValue?.alertTitle}</AlertTitle>
                {flagValue?.alertMessage && (
                  <Typography variant="body1" dangerouslySetInnerHTML={{ __html: flagValue.alertMessage }} />
                )}
              </Alert>
            )}
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            gap="30px"
            mb="30px"
            sx={{ width: '100%', boxSizing: 'border-box' }}
          >
            <Box flex={{ xs: '1 1 100%', md: '3 1 0%' }} minWidth={0} sx={{ boxSizing: 'border-box' }}>
              <Container maxWidth="100%" paperPadding={30} marginTop={0} marginBottom={0}>
                <WelcomeCard firstName={user?.given_name} />
              </Container>
            </Box>
            <Box flex={{ xs: '1 1 100%', md: '2 1 0%' }} minWidth={0} sx={{ boxSizing: 'border-box' }}>
              <Container height="100%" maxWidth="100%" paperPadding={30} marginTop={0} marginBottom={0}>
                <MintBurnSummary />
              </Container>
            </Box>
          </Box>
          {/* TODO: Revisit once requirements are firm */}
          {/* <Box mb="30px">
            <Container maxWidth="100%" marginTop={0} marginBottom={0} paperPadding={40}>
              <QCADHoldingsChart />
            </Container>
          </Box> */}
        </S.SummaryContainer>
        <Container maxWidth="100%" marginTop={0} marginBottom="90px" paperPadding={40}>
          <Box display="flex" mb="32px" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" fontWeight={400}>
              Recent Orders
            </Typography>
            <Link href="/orders">view more</Link>
          </Box>
          {fetching ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress disableShrink />
            </Box>
          ) : orders.length ? (
            <OrdersTable orders={orders} onRefresh={fetchOrders} />
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center" height="100px">
              <Typography variant="h6">No Orders</Typography>
            </Box>
          )}
        </Container>
      </S.LeftSection>
    </S.DashboardContainer>
  )
}

export default Dashboard
